import React, { useEffect, useState } from 'react';
import { AuthPage } from '../UserAuth/AuthPage';
import { adminAuthService } from '../../services/adminAuthService';
import { useAdminAuthStore } from '../../stores/adminAuthStore';

interface ControlProtectedRouteProps {
  children: React.ReactNode;
}

export const ControlProtectedRoute: React.FC<ControlProtectedRouteProps> = ({ children }) => {
  const [ready, setReady] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const initialize = useAdminAuthStore((s) => s.initialize);

  useEffect(() => {
    initialize();
    setAuthenticated(adminAuthService.isAuthenticated());
    setReady(true);

    const onAdminLogin = () => setAuthenticated(true);
    const onAdminLogout = () => setAuthenticated(false);

    window.addEventListener('admin-login-success', onAdminLogin);
    window.addEventListener('admin-logout', onAdminLogout);
    window.addEventListener('auth-logout', onAdminLogout);

    return () => {
      window.removeEventListener('admin-login-success', onAdminLogin);
      window.removeEventListener('admin-logout', onAdminLogout);
      window.removeEventListener('auth-logout', onAdminLogout);
    };
  }, [initialize]);

  if (!ready) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        正在检查管理员登录状态...
      </div>
    );
  }

  if (!authenticated) {
    return <AuthPage initialLoginMethod="admin" adminRedirect />;
  }

  return <>{children}</>;
};
